import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "22",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#98A2B3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M7.833 2.833a.833.833 0 1 0 1.667 0 .833.833 0 0 0-1.667 0ZM2 2.833a.833.833 0 1 0 1.667 0 .833.833 0 0 0-1.667 0ZM7.833 8.155a.833.833 0 1 0 1.667 0 .833.833 0 0 0-1.667 0ZM2 8.155a.833.833 0 1 0 1.667 0 .833.833 0 0 0-1.667 0ZM7.833 13.476a.833.833 0 1 0 1.667 0 .833.833 0 0 0-1.667 0ZM2 13.476a.833.833 0 1 0 1.667 0 .833.833 0 0 0-1.667 0ZM7.833 18.797a.833.833 0 1 0 1.667 0 .833.833 0 0 0-1.667 0ZM2 18.797a.833.833 0 1 0 1.667 0 .833.833 0 0 0-1.667 0Z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }